export const state = {
  pager: {},
  pagerRequest: {},
  pagerActivity: {},
};

export const mutations = {
  INIT_PAGER(state, payload) {
    state.pager = payload;
  },
  INIT_PAGER_REQUEST(state, payload) {
    state.pagerRequest = payload;
  },
  INIT_PAGER_ACTIVITY(state, payload) {
    state.pagerActivity = payload;
  },
};

export const actions = {
  getPager({ commit }, payload) {
    commit("INIT_PAGER", payload);
  },
  getPagerRequest({ commit }, payload) {
    commit("INIT_PAGER_REQUEST", payload);
  },
  getPagerActivity({ commit }, payload) {
    commit("INIT_PAGER_ACTIVITY", payload);
  },
};

export const getters = {
  getPager: (state) => state.pager,
  getPagerRequest: (state) => state.pagerRequest,
  getPagerActivity: (state) => state.pagerActivity,
};
